export default {"src":"/_next/static/media/Meta_Cartel.fac7ac78.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};